/* ==========================================================================
   ODYSSÉE ACADEMY : mega-menus desktop (≥992px), « s'entraîner » / « boutique »
   SPEC-BLOG-POPUPS-MEGAMENUS.md §Partie 4.6.

   Convention de classe choisie : .is-open partout (panneau, voile ET toggle),
   IDENTIQUE à celle de l'accordéon mobile déjà porté dans assets/theme.js :
   PAS .is-sub-open comme le script Webflow d'origine (qui distinguait les
   deux). Les deux mécaniques ne se marchent jamais dessus : chacune se
   retire au sortir de son propre viewport (voir isDesktop() ci-dessous et
   les gardes équivalentes dans theme.js), et le fait de partager .is-open
   sur le toggle est même un bénéfice : le lien passe en rouge et le caret
   tourne via les règles déjà écrites dans header.liquid
   (.nav-dropdown-toggle.is-open > .nav-link / .nav-caret), sans rien
   dupliquer ici.

   Fichier dédié (pas theme.js) : le panneau est un composant à part entière,
   chargé defer depuis layout/theme.liquid. Sous 992px, ce script ne fait
   STRICTEMENT rien (tous les handlers de survol/clic renvoient tôt) : c'est
   initSubmenus() de theme.js qui gère déjà l'accordéon .nav-submenu.
   ========================================================================== */
(function () {
  'use strict';

  var MQ = window.matchMedia('(min-width: 992px)');
  var OPEN_DELAY = 90, CLOSE_DELAY = 180;
  var openT = null, closeT = null, current = null;

  function isDesktop() { return MQ.matches; }

  /* Dupliquée volontairement pour que ce fichier reste autonome : theme.js
     mesure déjà --oda-nav-h au chargement/redimensionnement, on la
     rafraîchit ici à CHAQUE ouverture (le texte de la navbar peut avoir
     changé de hauteur juste avant), comme le fait le script Webflow.
     05/09 : mesure aussi la topbar (sections/topbar.liquid, --oda-topbar-h),
     même logique que theme.js -- copie tenue à jour en parallèle. */
  function measureNav() {
    var navbar = document.querySelector('[data-navbar]');
    var topbar = document.querySelector('[data-topbar]');
    var topbarH = topbar ? topbar.offsetHeight : 0;
    document.documentElement.style.setProperty('--oda-topbar-h', topbarH + 'px');
    if (navbar) document.documentElement.style.setProperty('--oda-nav-h', (navbar.offsetHeight + topbarH) + 'px');
  }

  function parts(key) {
    return {
      toggle: document.querySelector('[data-mega="' + key + '"]'),
      panel: document.querySelector('[data-mega-panel="' + key + '"]'),
      veil: document.querySelector('[data-mega-veil="' + key + '"]')
    };
  }

  function setState(key, open) {
    var p = parts(key);
    if (!p.panel) return;
    p.panel.classList.toggle('is-open', open);
    if (p.veil) p.veil.classList.toggle('is-open', open);
    if (p.toggle) {
      p.toggle.classList.toggle('is-open', open);
      var a = p.toggle.querySelector('.nav-link');
      if (a) a.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (open) current = key; else if (current === key) current = null;
  }

  function openMenu(key) {
    if (!isDesktop()) return;
    clearTimeout(closeT);
    if (current && current !== key) setState(current, false);
    measureNav();
    setState(key, true);
  }

  function closeMenu(key) { clearTimeout(openT); setState(key, false); }

  function closeAll() {
    clearTimeout(openT); clearTimeout(closeT);
    var list = document.querySelectorAll('[data-mega-panel]');
    for (var i = 0; i < list.length; i++) setState(list[i].getAttribute('data-mega-panel'), false);
    current = null;
  }

  function scheduleClose(key) {
    clearTimeout(openT); clearTimeout(closeT);
    closeT = setTimeout(function () { closeMenu(key); }, CLOSE_DELAY);
  }

  function init() {
    var toggles = document.querySelectorAll('[data-mega]');
    if (!toggles.length) return;
    measureNav();

    toggles.forEach(function (tg) {
      var key = tg.getAttribute('data-mega');
      var p = parts(key);
      if (!p.panel) return;

      /* Survol du toggle OU du panneau (les deux zones sont attachées) :
         ouverture programmée après 90ms (évite l'ouverture parasite si la
         souris traverse juste le lien en passant). */
      [tg, p.panel].forEach(function (el) {
        el.addEventListener('mouseenter', function () {
          if (!isDesktop()) return;
          clearTimeout(closeT); clearTimeout(openT);
          openT = setTimeout(function () { openMenu(key); }, OPEN_DELAY);
        });
        el.addEventListener('mouseleave', function () {
          if (!isDesktop()) return;
          scheduleClose(key);
        });
      });

      /* Focus clavier : ouverture IMMÉDIATE, pas de délai. */
      tg.addEventListener('focusin', function () {
        if (isDesktop()) openMenu(key);
      });

      /* Clic sur le lien du toggle, desktop uniquement (sous 992px,
         initSubmenus() de theme.js gère déjà le clic pour l'accordéon,
         cf. la garde isDesktop() plus haut dans chaque handler ici). */
      var link = tg.querySelector('.nav-link');
      if (link) {
        link.addEventListener('click', function (e) {
          if (!isDesktop()) return;
          var href = link.getAttribute('href') || '#';
          var isOpen = p.panel.classList.contains('is-open');
          /* Panneau déjà ouvert au survol ET vrai lien (cas "boutique") :
             navigation normale, rien n'est bloqué. */
          if (href !== '#' && isOpen) return;
          /* Panneau fermé, ou lien sans vraie destination (cas
             "s'entraîner", href="#") : bascule le panneau au lieu de
             suivre le lien : rend le menu utilisable au tactile sur grand
             écran (tablette en mode desktop, pas de vrai hover). */
          e.preventDefault();
          if (isOpen) closeMenu(key); else openMenu(key);
        });
      }

      /* Bloque le scroll de la page derrière un panneau ouvert. */
      function blockScroll(e) { if (p.panel.classList.contains('is-open')) e.preventDefault(); }
      p.panel.addEventListener('wheel', blockScroll, { passive: false });
      p.panel.addEventListener('touchmove', blockScroll, { passive: false });
      if (p.veil) {
        p.veil.addEventListener('wheel', blockScroll, { passive: false });
        p.veil.addEventListener('touchmove', blockScroll, { passive: false });
        p.veil.addEventListener('click', function () { closeMenu(key); });
      }

      /* Un CTA data-booking à l'intérieur du panneau (ex. "réserver un
         essai") referme tous les mega-menus avant que la popup de
         réservation ne s'ouvre par-dessus. */
      var ctas = p.panel.querySelectorAll('[data-booking]');
      for (var c = 0; c < ctas.length; c++) {
        ctas[c].addEventListener('click', function () { closeAll(); });
      }
    });

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && current) closeAll();
    });

    document.addEventListener('click', function (e) {
      if (!current) return;
      var p = parts(current);
      if (p.panel && p.panel.contains(e.target)) return;
      if (p.toggle && p.toggle.contains(e.target)) return;
      closeAll();
    });

    window.addEventListener('resize', function () {
      measureNav();
      if (!isDesktop()) closeAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* L'éditeur de thème recharge les sections sans recharger la page. */
  document.addEventListener('shopify:section:load', init);
})();
